/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: 'summary-grid',
    templateUrl: './summary-grid.component.html',
    styleUrls: ['./summary-grid.component.scss']
})
// @formatter:on
export class SummaryGridComponent {
}
